exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapsible-widget-body[data-v-7e9e4441] {\n  margin-left: 10px;\n}\n", ""]);

// exports
